<template>
  <div class="order-form-component">

    <!-- Introduction -->
    <div class="introduction">
      <div class="row mb-0">
        <div class="col-12">
          <h3>{{ sectionTwoHeading }}</h3>
          <div v-html="description"></div>
        </div>
      </div>
    </div>

    <div class="product-details-component" v-if="quote">

      <div class="vehicle-details">
        <vehicle-card :derivative="quote.derivative" :quote="quote" :quoteCosts="quoteCosts" :type="'salsac'"/>
        <div class="row">
          <div class="col-12">
            <b>Please ensure you
              selected an interior seat trim and interior embellishment trim (if available) within
              the Trim section of the Optional Extras</b>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>We place your order with a requested delivery of as soon as possible. If you require the delivery around a specific date please let us know in the below box.</p>
            <div class="form-group">
              <textarea name="deliveryNotes" v-model="deliveryNotes" class="form-control" rows="5"></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="agree mb-0">
              <input type="checkbox" name="disclaimer" id="disclaimer_2" class="disclaimer_2"
                v-model="confirmations.correctVehicle">
              <label for="disclaimer_2">{{ declaration }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="extra-options" v-if="options.length">
        <template v-for="(option, index) in options">
          <div class="row">
            <div class="col-12">

              <h3>{{ option.title }}</h3>
              <p v-if="option.description && option.description !== '<p><br></p>'" v-html="option.description"></p>

              <div class="agree mb-0">
                <input type="checkbox" v-bind:name="'option_'+index" v-bind:id="'option_'+index" v-model="optionSelections[option.title]" :checked="optionSelections[option.title]" class="confirm">
                <label v-bind:for="'option_'+index">{{ option.option_text }}</label>
              </div>

            </div>
          </div>
        </template>
      </div>

    </div>
  </div>
</template>
<script>
import {EventBus} from '@/event-bus.js';

export default {
  data() {
    return {
      deliveryNotes: ''
    }
  },
  props: [
    'confirmations',
    'optionSelections',
    'derivative',
    'quote',
    'quoteCosts',
    'adminPortalData',
    'sectionTwoHeading',
    'currentProduct',
  ],

  watch: {
    confirmations: {
      handler(confirmations) {
        EventBus.$emit('setConfirmations', confirmations);
      },
      deep: true
    },
    optionSelections: {
      handler(optionSelections) {
        this.options.forEach((option, key) => {
          if (optionSelections[option.title] !== undefined) {
            this.options[key].selected = optionSelections[option.title];
          }
        });

        EventBus.$emit('setOptionSelections', this.options);
      },
      deep: true
    },
    deliveryNotes: {
      handler(deliveryNotes) {
        this.$parent.$parent.deliveryNotes = deliveryNotes;
      }
    },
  },

  computed: {
    description() {
      return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_two_section_two_description : '';
    },
    declaration() {
      return this.adminPortalData.content ? this.adminPortalData.content.products.salsac[0].order_stage_two_declaration_text : '';
    },
    options() {
      return this.currentProduct.order_stage_extra_options || [];
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === 'Login') {
      next();
    }

    if (to.name === 'Salary Sacrifice Order Details') {
      document.getElementById('order-process-wrap').scrollTo({top: 0, behavior: 'smooth'});
      if (!this.confirmations.correctVehicle) {
        EventBus.$emit('showError', true);
        EventBus.$emit('errorTitle', 'Please confirm all points to continue');
        EventBus.$emit('errorMessage', '');
        return false;
      }
    }
    EventBus.$emit('setOptionSelections', this.options);
    next();
  },

  methods: {}
}
</script>
